import { LayoutHOC } from 'base/ui/layout/layout';

import { EventCampaignRoutes } from './routes';
import createEventReport from './report';

export const createEventCampaignPage = (layoutHOC: LayoutHOC) => {
  const EventReport = createEventReport();
  const EventCampaignPage = layoutHOC(EventCampaignRoutes);

  return () => <EventCampaignPage DetailReport={EventReport} />;
};
